// @ts-nocheck
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import general from '../images/general01.png';
import Section0 from '../components/blogs/section0';
import Section2 from '../components/blogs/section2';
import HeaderBlog from '../components/blogs/headerBlog';
import SubheaderBlog from '../components/blogs/subheaderBlog';

const Blog1 = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-20 ">
        <HeaderBlog text={
          "ПОСЛАННЯ ГЕНЕРАЛЬНОГО НАСТОЯТЕЛЯ САЛЕЗІЯН, ОТЦЯ ФАБІО АТТАРДА, СДБ"
        } />
        <SubheaderBlog text={
          "ВИКЛИК НАШІЙ ЛЮДЯНОСТІ"
        } />
        <Section0 photo={general} />
        <Section2
          title={"Багатство, яке ризикує зробити нас сліпими й глухими"}
          text1={`
              Притча про багатого і бідного Лазаря, яку ми знаходимо в Євангелії від Луки (16, 19–31), це не просто історія про справедливий розподіл матеріальних багатств. Це розповідь, яка проникає в саме серце людського буття й ставить перед нами тривожне запитання: хто насправді ким володіє? Чи багатий володів своїм багатством, чи це багатство володіло ним, перетворюючи його на свого раба?
            `}
          text2={`
              Ця зміна перспективи відкриває простір для глибоких роздумів. Людину з притчі було засуджено не за те, що вона крала чи експлуатувала інших, а за те, що стала сліпою і глухою. Її трагедія полягала не в тому, що вона мала, а в тому, що не бачила і не чула. Вона жила у світі, зведеному лише до меж власного дому, своїх статків і негайного добробуту. Біля воріт її дому лежав Лазар, укритий ранами, які лизали пси, але цей бідняк став невидимим, а його мовчазний крик - нечутним.
            `} text3={undefined} />
        <Section2
          title={"Екзистенційне багатство"}
          text1={`
Коли ми говоримо про багатство, то зазвичай одразу думаємо про гроші, матеріальні блага, економічний успіх. Але існує багатство тонше й всеохопніше — екзистенційне. Це багатство тих, кому добре, хто знайшов власну зону комфорту, хто живе в оточенні позитивних стосунків, приємних досвідів і заспокійливих упевненостей. Це багатство спільноти, яка добре функціонує, групи, де тебе приймають, середовища, в якому все плине легко й приємно.
            `}
          text2={`
Це екзистенційне багатство є даром - у цьому немає сумніву. Справедливо ним тішитися, святкувати його, усвідомлювати красу того, чим живеш. Але саме тут приховується найпідступніша небезпека: замкнутися в цій достатності, перетворити простір добробуту на позолочене гетто, відокремлене від навколишньої реальності.
Багатий із притчі жив саме так. Йому нічого не бракувало, і водночас йому бракувало всього: здатності бачити поза межами себе, відчувати іншого, дозволити реальності, що стукала в його двері, торкнутися його серця. Його багатство стало невидимою в’язницею з ґратами, зробленими зі звички, байдужості та самозосередженості.
            `} text3={undefined} />
        <Section2
          title={
            "Сліпота і глухота комфорту"
          }
          text1={
            `
              Зона комфорту — одне з найнебезпечніших понять сучасності. Вона вводить нас в оману, переконуючи, що добробут є правом, яке треба захищати, а не даром, яким слід ділитися. Вона переконує нас, що збереження власної рівноваги важливіше, ніж відкритість до крику інших. Вона нашіптує, що ми вже зробили достатньо, що можемо нарешті розслабитися, що проблеми інших нас безпосередньо не стосуються.
            `
          }
          text2={
            `
              Сліпота багатого не була фізичною, а духовною. Він бачив свій палац, свій одяг, свій щедро накритий стіл. Але він не бачив Лазаря. Не тому, що Лазар був схований, а тому, що багатий розвинув у собі особливу форму сліпоти, яка фільтрує реальність, пропускаючи лише те, що підтверджує власне бачення світу.
            `
          }
          text3={
            `
              Була й глухота. Текст відкриває нам цей другий недолік, коли чоловік із потойбіччя благає Авраама послати когось із мертвих, щоб його брати послухали. Але саме він не слухав! Він був глухий до мовчазного крику бідності, до того страждання, яке не волає, але триває, яке не заважає, але існує, яке не вимагає, а чекає.
            `
          }
        />
        <Section2
          title={
            "Внутрішнє слухання як необхідна умова зовнішнього слухання"
          }
          text1={
            `
              Як подолати цей подвійний параліч - сліпоту й глухоту? Відповідь не полягає у простому зусиллі волі чи в програмі соціальної діяльності. Вона полягає у глибшому наверненні: ми не можемо побачити Христа в бідному, якщо не споглядаємо Христа всередині себе. Ми не можемо почути крик вразливих, якщо не налаштовані на голос Бога у власному серці.
            `
          }
          text2={
            `
              Великі свідки милосердя - від отця Боско до Матері Терези з Калькутти - починали не з соціологічного аналізу бідності, а з містичного досвіду Божої любові. Їхня здатність бачити, слухати й відповідати назовні народжувалася з внутрішнього життя з контемпляції, яка не була втечею від світу, а підготовкою до зустрічі зі світом.
            `
          }
          text3={
            `
              У цьому й полягає парадокс: що глибше людина сходить у глибини власного серця, щоб розпізнати там Божу любов, то більшої здатності вона набуває виходити за межі себе, щоб зустріти іншого. Духовне життя - це не нарцистичне замикання в собі, а необхідне тренування для розвитку тієї чутливості, яка дозволяє нам розпізнавати Христа всюди, де Він себе об’являє.
            `
          }
        />
        <Section2
          title={
            "Місія як поділення багатства"
          }
          text1={
            `
              Кожна людина - це місія. Це твердження не означає, що всі ми повинні ставати гарячковими активістами чи братися за грандіозні проєкти. Воно радше означає, що багатство, яке ми отримали - матеріальне, культурне, духовне, екзистенційне, - не є нашою винятковою власністю, а даром, призначеним для руху, для передавання іншим.
            `
          }
          text2={
            `
              Той, хто любить, приходить у рух, виходить за межі себе, дозволяє себе притягнути й сам притягує інших. Любов за своєю природою динамічна: її неможливо накопичити, зберегти чи замкнути в зоні комфорту. Або ми нею ділимося - або втрачаємо її. Або дозволяємо їй циркулювати - або вона псується.
            `
          }
          text3={
            `
              Отже, виклик полягає не у відмові від екзистенційного багатства, а в іншому способі володіння ним: не як ревниві власники, а як щедрі управителі; не як кінцеві отримувачі, а як канали передавання; не як точка прибуття, а як точка відліку для нових шляхів спільності й ділення. 
            `
          }
        />
        <Section2
          title={
            "Творча меншість і знаки надії"
          }
          text1={
            `
              У світі, позначеному зростаючою нерівністю та структурною байдужістю, ті, хто вирішує не ставати сліпими й глухими, неминуче стають меншістю. Але це творча меншість, здатна запалювати вогники надії - навіть малі, але безперечно заразливі.
            `
          }
          text2={
            `
              Надія - це не наївний оптимізм і не пасивна покора. Надія - це Особа: Христос, Який і далі звертається до нас через кожного Лазаря, що лежить при порозі нашого життя. Розпізнати Його там - у спотвореному обличчі бідного, у мовчазному крику виключеного, в ігнорованому стражданні вразливого - це єдиний спосіб не стати рабами власного багатства і не бути знищеними власним добробутом.
            `
          }
          text3={
            `
              Притча залишає нас із відчуттям нагальності: сьогодні, зараз, перш ніж стане надто пізно, відкрити очі й вуха на реальність, що нас оточує. Бо завтра, по той бік, уже не матиме жодного сенсу шкодувати про те, що ми не побачили й не почули.
            `
          }
        />
        <div className="flex justify-between py-10 italic font-semibold">
          <div></div>
          <div>січень 2026 р.</div>
        </div>
      </div>
    </>
  );
};

export default Blog1;
